var map = {
	"./HomeCover.jpg": 78,
	"./JS.png": 38,
	"./Kladersbyte.jpg": 79,
	"./Puppies-typeScript-React.jpg": 80,
	"./Sign.png": 36,
	"./TS.png": 43,
	"./Ubiquiti-screenshot.jpg": 81,
	"./bootstrap.png": 39,
	"./csharp.png": 49,
	"./css.png": 47,
	"./english-teacher.jpg": 82,
	"./expressjs.png": 45,
	"./git.png": 46,
	"./github-getter.jpg": 83,
	"./html.png": 37,
	"./mongodb.png": 48,
	"./movieDB.jpg": 84,
	"./muzikawy.jpg": 85,
	"./net_core.png": 50,
	"./nodejs.png": 44,
	"./php.png": 42,
	"./profilePic.jpg": 51,
	"./react.png": 40,
	"./redux.png": 41,
	"./todoList.jpg": 86,
	"./travellogger-screenshot.jpg": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;